import { Injectable } from '@angular/core';
import {
  IQuoteMetadata,
  MetadataTypeEnum,
  QuoteRequestService,
  QuoteService,
  ShipperQuoteService,
} from '@cai-services';
import { QuoteRequestsMetadata } from '../_models/quote-request-metadata.model';
import { ShipperQuoteRequestsMetadata } from '../_models/shipper-quote-request-metadata.model';

@Injectable({
  providedIn: 'root',
})
export class MetadataService {
  constructor(
    private readonly quoteService: QuoteService,
    private readonly quoteRequestService: QuoteRequestService,
    private readonly shipperQuoteService: ShipperQuoteService,
  ) {}

  async getQuoteMetadata(
    type: MetadataTypeEnum,
    filterOptions: { [key: string]: any },
    origin?: string[],
    destination?: string[],
    airline?: string[],
    commodity?: string[],
    forwarder?: string[],
    bookingType?: string[],
    search?: string,
  ): Promise<IQuoteMetadata> {
    return this.quoteService.getQuoteMetadata(
      type,
      filterOptions?.fromDate,
      filterOptions?.toDate,
      origin,
      destination,
      airline,
      commodity,
      forwarder,
      bookingType,
      search,
    );
  }

  async getQuoteRequestMetadata(
    type: MetadataTypeEnum,
    filterOptions: { [key: string]: any },
    origin?: string[],
    destination?: string[],
    airline?: string[],
    commodity?: string[],
  ): Promise<QuoteRequestsMetadata> {
    return this.quoteRequestService.getQuoteRequestMetadata(
      type,
      filterOptions?.fromDate,
      filterOptions?.toDate,
      origin,
      destination,
      airline,
      commodity,
    ) as Promise<QuoteRequestsMetadata>;
  }

  async getShipperQuoteRequestMetadata(
    filterOptions,
  ): Promise<ShipperQuoteRequestsMetadata> {
    return this.shipperQuoteService.getShipperQuoteRequestsMetadata(
      filterOptions?.fromDate,
      filterOptions?.toDate,
      filterOptions?.origin,
      filterOptions?.destination,
      filterOptions?.airline,
      filterOptions?.commodity,
      filterOptions?.search,
    ) as Promise<ShipperQuoteRequestsMetadata>;
  }
}
